/* eslint-disable no-console */

import { register } from "register-service-worker";

const registerServiceWorker = false;

if (process.env.NODE_ENV === "production" && registerServiceWorker) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );

      /*Notification.requestPermission(function(status) {
        console.log("requestPermission_status: ", status);
      });*/
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      // ps: registration is an instace of ServiceWorkerRegistration
      console.log("New app version is available; please refresh.");
      document.dispatchEvent(
        new CustomEvent("swUpdated", { detail: registration })
      );
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
